import React, { useCallback, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { changeRightSidebarStatus } from '../../state/ui/actions';
import { APP_ROUTES } from '../../constants/appRoutes';
import { getRightSidebar } from '../../state/ui/selectors';
import { ButtonsCollection } from '..';

import './style.sass';

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */

const ToggleRightSideBarButton = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation('common');
  const status = useSelector(getRightSidebar);
  const dispatch = useDispatch();

  const toggleRightSideBarHandler = useCallback(() => {
    dispatch(changeRightSidebarStatus(!status));
  }, [status]); // eslint-disable-line

  if (pathname.indexOf(APP_ROUTES.TASK) !== -1) {
    return null;
  }

  return (
    <ButtonsCollection.ButtonIcons
      title={t('Toggle right side bar')}
      className={classNames('toggle-right-aside', { 'toggle-right-aside--active': status })}
      onClick={toggleRightSideBarHandler}
    >
      <span className="icon-toggle-right-sidebar" />
    </ButtonsCollection.ButtonIcons>
  );
};

export default memo(ToggleRightSideBarButton);
